<template>
  <q-card class="social-accounts-card">
    <q-toolbar class="text-positive">
      <q-toolbar-title>
        Social Accounts
      </q-toolbar-title>
      <q-icon name="fa fa-share-alt" size="sm" />
    </q-toolbar>
    <q-separator />
    <q-card-section>
      <social-accounts-loader
        :client-id="clientId"
        v-model="socialAccounts"
      />
      <div class="row">
        <div class="col-6">
          <span class="text-h3 text-bold">{{ socialAccounts.length }}</span>
          Account<span v-show="socialAccounts.length !== 1">s</span>
        </div>
        <div class="col-6 text-right" style="align-self: flex-end">
          <social-accounts-btn
            :client-id="clientId"
            label="View Social Accounts"
            flat
            rounded
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.social-accounts-card {
  border-bottom: 3px solid $positive;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import SocialAccountsLoader from '@/social/account/AccountsLoader.vue';
import { SocialAccount } from '@/type';
import SocialAccountsBtn from '@/social/account/AccountsBtn.vue';

interface Data {
  socialAccounts: SocialAccount[]
}

export default defineComponent({
  components: { SocialAccountsBtn, SocialAccountsLoader },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      socialAccounts: [],
    };
  },
});
</script>
